module.exports = __webpack_public_path__ + "img/service-zhinengyingxiao2.9540363f.svg";